module.exports = __webpack_public_path__ + "static/10-groa-79e1e074498f8f209785a28e8528c923.jpg";